import { FormType } from '../../../form-types';
import { AlcoholFieldAnswers } from '../questions';

const alcohol: FormType<AlcoholFieldAnswers> = {
  name: 'Alcohol',
  questions: [
    {
      key: 'alcohol_sexAssignedAtBirth',
      next: {
        condition: {
          'alcohol_sexAssignedAtBirth.female': true
        },
        key: 'alcohol_pregnancyStatus',
        els: 'alcohol_heightFeet'
      }
    },
    {
      key: 'alcohol_pregnancyStatus',
      next: {
        condition: {
          'alcohol_pregnancyStatus.yes': true
        },
        key: 'alcohol_ineligible',
        els: 'alcohol_consentPregnancy'
      }
    },
    {
      key: 'alcohol_consentPregnancy',
      next: {
        condition: {
          'alcohol_consentPregnancy.non_consent': true
        },
        key: 'alcohol_ineligible',
        els: 'alcohol_heightFeet'
      }
    },
    'alcohol_heightFeet',
    'alcohol_weightPounds',
    {
      key: 'alcohol_consentAbruptDiscontinuation',
      next: {
        condition: {
          'alcohol_consentAbruptDiscontinuation.non_consent': true
        },
        key: 'alcohol_ineligible',
        els: 'alcohol_programGoal'
      }
    },
    {
      key: 'alcohol_programGoal',
      next: {
        condition: {
          'alcohol_programGoal.other': true
        },
        key: 'alcohol_programGoalOther',
        els: 'alcohol_issuesDuration'
      }
    },
    'alcohol_programGoalOther',
    'alcohol_issuesDuration',
    {
      key: 'alcohol_withdrawalHistory',
      next: {
        condition: {
          'alcohol_withdrawalHistory.yes': true
        },
        key: 'alcohol_withdrawalComplications',
        els: 'alcohol_recentAbstinence'
      }
    },
    {
      key: 'alcohol_withdrawalComplications',
      next: {
        condition: {
          'alcohol_withdrawalComplications.no': true
        },
        key: 'alcohol_recentAbstinence',
        els: 'alcohol_ineligible'
      }
    },
    {
      key: 'alcohol_recentAbstinence',
      next: {
        condition: {
          'alcohol_recentAbstinence.yes': true
        },
        key: 'alcohol_withdrawalSymptoms',
        els: 'alcohol_weekdayDrinks'
      }
    },
    'alcohol_withdrawalSymptoms',
    'alcohol_consumptionChange',
    'alcohol_weekdayDrinks',
    'alcohol_weekendDrinks',
    'alcohol_cravingTime',
    {
      key: 'alcohol_medicalConditions',
      next: {
        switch: [
          {
            condition: {
              'alcohol_medicalConditions.ckd': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.parkinsons': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.diabetes': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.heart': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.respiratory': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.liver': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.urinating': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.metabolic': true
            },
            key: 'alcohol_ineligible'
          },
          {
            condition: {
              'alcohol_medicalConditions.none': true
            },
            key: 'alcohol_naltrexoneContraindications'
          },
          {
            condition: {
              'alcohol_medicalConditions.sleep_apnea': true
            },
            key: 'alcohol_sleepApneaControl'
          }
        ],
        els: 'alcohol_ineligible'
      }
    },
    'alcohol_sleepApneaControl',
    // At the moment our use case is for Naltrexone. If we support more than Naltrexone, we will have to check eligibility in post.
    {
      key: 'alcohol_naltrexoneContraindications',
      next: {
        condition: {
          'alcohol_naltrexoneContraindications.none': true
        },
        key: 'alcohol_baclofenContraindications',
        els: 'alcohol_ineligible'
      }
    },
    'alcohol_baclofenContraindications',
    'alcohol_additionalQuestions',
    {
      key: 'alcohol_consentTruthfulness',
      next: {
        condition: {
          'alcohol_consentTruthfulness.consent': true
        },
        key: 'alcohol_consentPharmacotherapy',
        els: 'alcohol_ineligible'
      }
    },
    {
      key: 'alcohol_consentPharmacotherapy',
      next: {
        condition: {
          'alcohol_consentPharmacotherapy.consent': true
        },
        key: 'alcohol_complete',
        els: 'alcohol_ineligible'
      }
    },
    'alcohol_ineligible',
    'alcohol_complete'
  ]
};
export default alcohol;
